import { BackgroundFloatingBoxes } from "components/BackgroundFloatingBoxes"
import ContactUsForm from "components/ContactUsForm";
import CardsFooter from "components/Footers/CardsFooter";
import DemoNavbar from "components/Navbars/DemoNavbar"
import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
// reactstrap components
import {
    Container,
    Row,
    Col,
    Alert
} from "reactstrap";

const KNOWN_PLANS = ['basic', 'standard', 'premium', 'enterprise'];

// The pricing page links here with ?plan=<name> (e.g. Enterprise). Only
// accept known plan names so hand-edited URLs can't inject arbitrary copy.
const getPlanFromQuery = (search) => {
    const raw = new URLSearchParams(search || '').get('plan');
    if (!raw) return '';
    const normalized = raw.trim().toLowerCase();
    return KNOWN_PLANS.includes(normalized) ? normalized : '';
};

export const formatPlanName = (plan) => plan.charAt(0).toUpperCase() + plan.slice(1);

export const ContactUsPage = () => {
    const [successMessage, setSuccessMessage] = useState(null);
    const [errorMessage, setErrorMessage] = useState(null);
    const location = useLocation();
    const plan = getPlanFromQuery(location.search);
    return (<>
        <Helmet>
            <title>Contact Us - Convert Logistics</title>
            <meta name="description" content="Contact the Convert Logistics team for demos, Enterprise quotes, and support." />
        </Helmet>
        <DemoNavbar />
        <main>
            <div className="position-relative">
                {/* shape Hero */}
                <section className="section section-lg section-shaped pb-250">
                    <BackgroundFloatingBoxes color="default" />
                    <Row className="p-2">
                        <Col xs={1} md={3} lg={4}></Col>
                        <Col xs={10} md={6} lg={4} className="p-4 mt-5 bg-secondary">
                        {successMessage !== null ? (
                            <Alert color="success">{successMessage}</Alert>
                        ):(<>
                        {errorMessage !== null ? (
                            <Alert color="error">{errorMessage}</Alert>
                        ) : <></>}
                                <ContactUsForm 
                                    plan={plan}
                                    onSubmitSuccess={()=>{
                                        setSuccessMessage(plan
                                            ? `Thanks for reaching out about the ${formatPlanName(plan)} plan! We'll get back as soon as we can.`
                                            : "Thanks for reaching out! We'll get back as soon as we can.")
                                    }} 
                                    onSubmitFailed={(message)=>{
                                        setErrorMessage(message);
                                    }}
                                    hideCancelButton={true} 
                                />
                            </>
                        )}
                        </Col>
                    </Row>
                    {/* SVG separator */}
                    <div className="separator separator-bottom separator-skew">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            preserveAspectRatio="none"
                            version="1.1"
                            viewBox="0 0 2560 100"
                            x="0"
                            y="0"
                        >
                            <polygon
                                className="fill-white"
                                points="2560 0 2560 100 0 100"
                            />
                        </svg>
                    </div>
                </section>
                {/* 1st Hero Variation */}
            </div>

        </main>
        <br />
        <br />
        <br />
        <br />
        <CardsFooter />
    </>
    )
}